module.exports = __webpack_public_path__ + "img/Frame 213.8e7b921f.png";